import { render, staticRenderFns } from "./ContentSearchResults.vue?vue&type=template&id=a45ff7a4&scoped=true&"
import script from "./ContentSearchResults.vue?vue&type=script&lang=js&"
export * from "./ContentSearchResults.vue?vue&type=script&lang=js&"
import style0 from "./ContentSearchResults.vue?vue&type=style&index=0&id=a45ff7a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45ff7a4",
  null
  
)

export default component.exports